import { createContext, useState, useEffect } from 'react'

import translations from '@/locales/translations.json'
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '@/locales/languages'

const LanguageContext = createContext()

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(() => {
        const saved = localStorage.getItem('language')
        if (SUPPORTED_LANGUAGES.includes(saved)) return saved
        const browserLang = navigator.language?.split('-')[0]
        if (SUPPORTED_LANGUAGES.includes(browserLang)) return browserLang
        return DEFAULT_LANGUAGE
    })

    useEffect(() => {
        localStorage.setItem('language', language)
    }, [language])

    const t = (key, params = {}) => {
        const translation = translations[key]

        if (!translation) {
            console.warn(`Translation missing for key: ${key}`)
            return key
        }

        let text = translation[language] || translation[DEFAULT_LANGUAGE] || key

        Object.entries(params).forEach(([param, value]) => {
            text = text.replace(`{${param}}`, value)
        })

        return text
    }

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    )
}

export default LanguageContext
